export const reports = {
  saved: [
    { id: 'rep_1', name: 'Weekly performance', schedule: 'weekly' },
    { id: 'rep_2', name: 'Monthly board deck', schedule: 'monthly' },
  ],
};
